import "./icons.css";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import { CgMail } from "react-icons/cg";
import { IoIosCall } from "react-icons/io";
import Book from "../img/book.png"
const Icons = () => {
  return (
    <>
      <section className="icons">
        <ul className="icons-ul">
          <a href="tel:+919779096815 " target="_blank" className="">
            {" "}
            <li className="call">
              <IoIosCall />
            </li>
          </a>
          <a
            href="mailto:bestdealelectricals4444@gmail.com "
            target="_blank"
            className=""
          >
            {" "}
            <li className="mail">
              <CgMail />
            </li>
          </a>
          <a
            href="https://www.linkedin.com/in/best-deal-electricals-b9478831b "
            target="_blank"
            className=""
          >
            {" "}
            <li className="linkedin">
              <CiLinkedin />
            </li>
          </a>
          <a
            href="https://www.instagram.com/bestdeal_electricals?igsh=ZjVjbHI2ZDVnZnhy"
            target="_blank"
            className=""
          >
            {" "}
            <li className="instagram">
              <FaInstagram />
            </li>
          </a>
          <a href="https://wa.me/919779096815" target="_blank">
            {" "}
            <li className="whatsapp">
              <FaWhatsapp />
            </li>
          </a>
            <a href="/BROCHURE.pdf" target="_blank" rel="noopener noreferrer" className=" brochure-2 text-decoration-none ">
<li className="book"><img src={Book} className="book-img"/></li>

               </a> 
        </ul>
      </section>
    </>
  );
};

export default Icons;
